import { render, staticRenderFns } from "./CatalogoListPublic.vue?vue&type=template&id=3f8926de&scoped=true&lang=pug"
import script from "./CatalogoListPublic.vue?vue&type=script&lang=js"
export * from "./CatalogoListPublic.vue?vue&type=script&lang=js"
import style0 from "./CatalogoListPublic.vue?vue&type=style&index=0&id=3f8926de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8926de",
  null
  
)

export default component.exports